import Eight from "./Eight";
import Five from "./Five";
import Four from "./Four";
import Nine from "./Nine";
import One from "./One";
import Seven from "./Seven";
import Six from "./Six";
import Ten from "./Ten";
import Three from "./Three";
import Two from "./Two";
import Zero from "./Zero";

export const faces = {
    Zero,
    One,
    Two,
    Three,
    Four,
    Five,
    Six,
    Seven,
    Eight,
    Nine,
    Ten,
};
